import React, { useCallback, useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import Layout from "../components/Layout";
import { API } from "../api";

import { toasts } from "../components/AppToast";

import { FiPlus, FiEdit, FiCheckCircle } from "react-icons/fi";

// EMPTY FORM

const EMPTY_FORM = {
  code_name: "",
  from_date: "",
  to_date: "",
  discount: "",
  carmodel_ids: [],
};

// COMPONENT

export default function AddCoupon() {
  const navigate = useNavigate();
  const location = useLocation();

  
  // EDIT ID
  

  const couponId = location.state?.couponId;

  const isEdit = Boolean(couponId);

  
  // STATES
  

  const [form, setForm] = useState(EMPTY_FORM);

  const [carModels, setCarModels] = useState([]);

  const [loading, setLoading] = useState(false);

  const [saving, setSaving] = useState(false);

  
  // LOAD ALL CAR MODELS

  

  const loadCarModels = useCallback(async () => {
    try {
   
      // GET TOTAL
   

      const countRes = await API.get("/cars", {
        params: {
          page: 1,
          limit: 1,
          search: "",
          selectedcartype: 0,
        },
      });

      const total = Number(countRes.data?.total) || 0;

      // console.log("TOTAL CAR MODELS:", total);

      if (total === 0) {
        setCarModels([]);

        return;
      }

   
      // GET ALL CAR MODELS
   

      const res = await API.get("/cars", {
        params: {
          page: 1,
          limit: total,
          search: "",
          selectedcartype: 0,
        },
      });

      const models = Array.isArray(res.data?.data) ? res.data.data : [];

      // console.log("ALL CAR MODELS:", models);

      setCarModels(models);
    } catch (error) {
      console.error("LOAD CAR MODELS ERROR:", error);

      toasts.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to load car models"
      );
    }
  }, []);

  
  // LOAD COUPON FOR EDIT

  

  const loadCoupon = useCallback(async () => {
    if (!couponId) {
      setForm({
        ...EMPTY_FORM,
        carmodel_ids: [],
      });

      return;
    }

    try {
      setLoading(true);

      // console.log("LOADING COUPON:", couponId);

   
      // GET COUPON
   

      const response = await API.get(`/coupons/${couponId}`);

      // console.log("COUPON RESPONSE:", response.data);

   
      // GET ACTUAL COUPON OBJECT
   

      const coupon =
        response.data?.data || response.data?.coupon || response.data;

      if (!coupon) {
        toasts.error("Coupon data not found");

        return;
      }

      // console.log("COUPON:", coupon);

     
      // GET CAR MODEL IDS
     

      let selectedModels = [];

   

      if (Array.isArray(coupon.carmodel_ids)) {
        selectedModels = coupon.carmodel_ids
          .map((id) => String(id).trim())
          .filter(Boolean);
      }

   
      // FORMAT:
      //
      // carmodel_id: "30,31,33"
   
      else if (
        coupon.carmodel_id !== undefined &&
        coupon.carmodel_id !== null
      ) {
        selectedModels = String(coupon.carmodel_id)
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean);
      }

      // console.log("SELECTED CAR MODEL IDS:", selectedModels);

     
      // SET FORM
     

      setForm({
        code_name: coupon.code_name ?? "",

        from_date: coupon.from_date
          ? String(coupon.from_date).substring(0, 10)
          : "",

        to_date: coupon.to_date ? String(coupon.to_date).substring(0, 10) : "",

        discount: coupon.discount ?? "",

        carmodel_ids: selectedModels,
      });
    } catch (error) {
      console.error("LOAD COUPON ERROR:", error);

      toasts.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to load coupon"
      );
    } finally {
      setLoading(false);
    }
  }, [couponId]);

  
  // LOAD PAGE
  

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");

      return;
    }

    const loadPage = async () => {
      try {
        setLoading(true);

        
        // LOAD ALL CAR MODELS
        

        await loadCarModels();

        
        // EDIT
        

        if (couponId) {
          await loadCoupon();
        }

        
        // ADD
        
        else {
          setForm({
            ...EMPTY_FORM,
            carmodel_ids: [],
          });
        }
      } catch (error) {
        console.error("LOAD PAGE ERROR:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPage();
  }, [navigate, couponId, loadCarModels, loadCoupon]);

  
  // HANDLE NORMAL FIELD CHANGE
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  
  // CAR MODEL CHECKBOX
  

  const handleModelChange = (id) => {
    const modelId = String(id);

    setForm((prev) => {
      const current = Array.isArray(prev.carmodel_ids) ? prev.carmodel_ids : [];

      const exists = current.includes(modelId);

      return {
        ...prev,

        carmodel_ids: exists
          ? current.filter((item) => item !== modelId)
          : [...current, modelId],
      };
    });
  };

  
  // SELECT ALL
  

  const selectAll = () => {
    setForm((prev) => ({
      ...prev,

      carmodel_ids: carModels.map((car) => String(car.carmodel_id)),
    }));
  };

  
  // CLEAR ALL
  

  const clearAll = () => {
    setForm((prev) => ({
      ...prev,

      carmodel_ids: [],
    }));
  };

  
  // SAVE
  

  const handleSave = async () => {
   
    // CODE NAME
   

    if (!form.code_name.trim()) {
      toasts.error("Coupon code is required");

      return;
    }

   
    // FROM DATE
   

    if (!form.from_date) {
      toasts.error("From date is required");

      return;
    }

   
    // TO DATE
   

    if (!form.to_date) {
      toasts.error("To date is required");

      return;
    }

   
    // DATE VALIDATION
   

    if (form.to_date < form.from_date) {
      toasts.error("To date cannot be before From date");

      return;
    }

   
    // DISCOUNT
   

    if (
      form.discount === "" ||
      form.discount === null ||
      form.discount === undefined
    ) {
      toasts.error("Discount is required");

      return;
    }

    const discount = Number(form.discount);

    if (Number.isNaN(discount) || discount < 0 || discount > 100) {
      toasts.error("Discount must be between 0 and 100");

      return;
    }

   
    // CAR MODEL
   

    if (!Array.isArray(form.carmodel_ids) || form.carmodel_ids.length === 0) {
      toasts.error("Please select at least one car model");

      return;
    }

    try {
      setSaving(true);

      
      // REMOVE DUPLICATE MODEL IDS
      

      const carmodelIds = [
        ...new Set(
          form.carmodel_ids
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && id > 0)
        ),
      ];

      if (carmodelIds.length === 0) {
        toasts.error("Invalid car model selection");

        return;
      }

      
      // PAYLOAD
      

      const payload = {
        code_name: form.code_name.trim().toUpperCase(),

        from_date: form.from_date,

        to_date: form.to_date,

        discount: discount,

        carmodel_ids: carmodelIds,
      };

      // console.log("COUPON SAVE PAYLOAD:", payload);

      
      // UPDATE
      

      if (isEdit) {
        await API.put(`/coupons/${couponId}`, payload);

        toasts.success("Coupon updated successfully");
      }

      
      // CREATE
      
      else {
        await API.post("/coupons", payload);

        toasts.success("Coupon created successfully");
      }

      
      // BACK TO LIST
      

      setTimeout(() => {
        navigate("/coupon-code");
      }, 700);
    } catch (error) {
      console.error("SAVE COUPON ERROR:", error);

      toasts.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to save coupon"
      );
    } finally {
      setSaving(false);
    }
  };

  
  // LOADING
  

  if (loading) {
    return (
      <Layout activePage="Coupon Code">
        <main className="dashboard-main">
          <div className="user-form-loading">Loading coupon information...</div>
        </main>
      </Layout>
    );
  }

  
  // RENDER
  

  return (
    <Layout activePage="Coupon Code">
      <main className="dashboard-main">
        <div className="user-form-page">
          {/*  HEADER*/}

          <div className="user-form-header">
            <div className="d-flex align-items-center gap-2">
              <div className="form-card-icon">
                {isEdit ? <FiEdit size={24} /> : <FiPlus size={24} />}
              </div>

              <div>
                <h2 className="um-modal-title mb-0">
                  {isEdit ? "Edit Coupon" : "Add New Coupon"}
                </h2>

                <p className="form-card-sub mb-0">
                  {isEdit ? "Update coupon information" : "Create a new coupon"}
                </p>
              </div>
            </div>

            <button
              type="button"
              className="um-btn-secondary"
              onClick={() => navigate("/coupon-code")}
            >
              ← Back to Coupons
            </button>
          </div>

          {/*FORM CARD*/}

          <div className="user-form-card">
            {/*COUPON DETAILS */}

            <div className="sec-div">
              <span>Coupon Details</span>
            </div>

            <div className="row g-4">
              {/*  CODE NAME */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">Code Name *</label>

                <input
                  type="text"
                  name="code_name"
                  className="um-input"
                  value={form.code_name}
                  onChange={handleChange}
                  placeholder="Enter coupon code"
                  style={{
                    textTransform: "uppercase",
                  }}
                  maxLength={100}
                />
              </div>

              {/*FROM DATE */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">From Date *</label>

                <input
                  type="date"
                  name="from_date"
                  className="um-input"
                  value={form.from_date}
                  onChange={handleChange}
                />
              </div>

              {/* TO DATE */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">To Date *</label>

                <input
                  type="date"
                  name="to_date"
                  className="um-input"
                  value={form.to_date}
                  onChange={handleChange}
                />
              </div>

              {/*  DISCOUNT */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">Discount (%) *</label>

                <input
                  type="number"
                  name="discount"
                  min="0"
                  max="100"
                  step="1"
                  className="um-input"
                  value={form.discount}
                  onChange={handleChange}
                  placeholder="0 - 100"
                />
              </div>
            </div>

            {/* CAR MODELS */}

            <div className="module-permission-section">
              <div className="sec-divm">
                <span>Applicable Car Models</span>
              </div>

              {/* TOOLBAR */}

              <div className="module-toolbar">
                <span className="module-count">
                  {form.carmodel_ids.length} of {carModels.length} car models
                  selected
                </span>

                <div className="module-actions">
                  <button
                    type="button"
                    className="module-select-btn"
                    onClick={selectAll}
                    disabled={carModels.length === 0}
                  >
                    Select All
                  </button>

                  <button
                    type="button"
                    className="module-clear-btn"
                    onClick={clearAll}
                    disabled={form.carmodel_ids.length === 0}
                  >
                    Clear All
                  </button>
                </div>
              </div>

              {/*  MODEL LIST */}

              <div className="mod-grid">
                {carModels.length === 0 ? (
                  <div
                    style={{
                      padding: "20px",
                      color: "#777",
                    }}
                  >
                    No car models found.
                  </div>
                ) : (
                  carModels.map((car) => {
                    const id = String(car.carmodel_id);

                    const checked = form.carmodel_ids.includes(id);

                    return (
                      <div
                        key={car.carmodel_id}
                        className={`mod-chip ${checked ? "on" : ""}`}
                        onClick={() => handleModelChange(car.carmodel_id)}
                      >
                        <input
                          type="checkbox"
                          name="carmodel[]"
                          value={car.carmodel_id}
                          checked={checked}
                          onChange={() => handleModelChange(car.carmodel_id)}
                          onClick={(e) => e.stopPropagation()}
                        />

                        <span>{car.carmodel_name}</span>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {/* FOOTER */}

            <div className="user-form-footer">
              <button
                type="button"
                className="um-btn-secondary"
                onClick={() => navigate("/coupon-code")}
                disabled={saving}
              >
                Cancel
              </button>

              <button
                type="button"
                className="um-btn-primary"
                onClick={handleSave}
                disabled={saving || carModels.length === 0}
              >
                {saving ? (
                  <span className="spinner" />
                ) : (
                  <>
                    <FiCheckCircle />

                    {isEdit ? "Save Changes" : "Create Coupon"}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </main>

    </Layout>
  );
}
